// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__sz+OQ","bgImage":"Hero_bgImage__7BKC1","active":"Hero_active__AAmwq","cardsWrapper":"Hero_cardsWrapper__GPsqe","learnMoreBtn":"Hero_learnMoreBtn__Q7FsB"};